var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecRegular1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5360_312156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "#E2E5E5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_5360_312156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 57,
    width: 79,
    height: 36,
    rx: 4,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3193 70.5059H80.2861C81.6624 70.5059 82.6559 70.7064 83.2666 71.1074C83.8818 71.5085 84.1895 72.1419 84.1895 73.0078C84.1895 73.5911 84.0391 74.0765 83.7383 74.4639C83.4375 74.8512 83.0046 75.0951 82.4395 75.1953V75.2637C83.1413 75.3958 83.6562 75.6579 83.9844 76.0498C84.3171 76.4372 84.4834 76.9635 84.4834 77.6289C84.4834 78.5267 84.1689 79.2308 83.54 79.7412C82.9157 80.2471 82.0452 80.5 80.9287 80.5H77.3193V70.5059ZM78.9531 74.6348H80.5254C81.209 74.6348 81.708 74.5277 82.0225 74.3135C82.3369 74.0947 82.4941 73.7256 82.4941 73.2061C82.4941 72.7367 82.3232 72.3971 81.9814 72.1875C81.6442 71.9779 81.1064 71.873 80.3682 71.873H78.9531V74.6348ZM78.9531 75.9609V79.126H80.6895C81.373 79.126 81.888 78.9961 82.2344 78.7363C82.5853 78.472 82.7607 78.0573 82.7607 77.4922C82.7607 76.9727 82.583 76.5876 82.2275 76.3369C81.8721 76.0863 81.332 75.9609 80.6074 75.9609H78.9531ZM91.7227 80.5L91.4971 79.5088H91.415C91.1917 79.8597 90.8727 80.1354 90.458 80.3359C90.0479 80.5365 89.5785 80.6367 89.0498 80.6367C88.1338 80.6367 87.4502 80.4089 86.999 79.9531C86.5479 79.4974 86.3223 78.807 86.3223 77.8818V72.9395H87.9424V77.6016C87.9424 78.1803 88.0609 78.6156 88.2979 78.9072C88.5348 79.1943 88.9062 79.3379 89.4121 79.3379C90.0866 79.3379 90.5811 79.1374 90.8955 78.7363C91.2145 78.3307 91.374 77.654 91.374 76.7061V72.9395H92.9873V80.5H91.7227ZM98.0938 79.3379C98.4857 79.3379 98.8776 79.2764 99.2695 79.1533V80.3633C99.0918 80.4408 98.8617 80.5046 98.5791 80.5547C98.3011 80.6094 98.0117 80.6367 97.7109 80.6367C96.1888 80.6367 95.4277 79.8346 95.4277 78.2305V74.1562H94.3955V73.4453L95.5029 72.8574L96.0498 71.2578H97.041V72.9395H99.1943V74.1562H97.041V78.2031C97.041 78.5905 97.1367 78.8776 97.3281 79.0645C97.5241 79.2467 97.7793 79.3379 98.0938 79.3379ZM103.604 79.3379C103.995 79.3379 104.387 79.2764 104.779 79.1533V80.3633C104.602 80.4408 104.371 80.5046 104.089 80.5547C103.811 80.6094 103.521 80.6367 103.221 80.6367C101.699 80.6367 100.938 79.8346 100.938 78.2305V74.1562H99.9053V73.4453L101.013 72.8574L101.56 71.2578H102.551V72.9395H104.704V74.1562H102.551V78.2031C102.551 78.5905 102.646 78.8776 102.838 79.0645C103.034 79.2467 103.289 79.3379 103.604 79.3379ZM113.003 76.7061C113.003 77.9411 112.686 78.9049 112.053 79.5977C111.419 80.2904 110.537 80.6367 109.407 80.6367C108.701 80.6367 108.076 80.4772 107.534 80.1582C106.992 79.8392 106.575 79.3812 106.283 78.7842C105.992 78.1872 105.846 77.4945 105.846 76.7061C105.846 75.4801 106.16 74.5231 106.789 73.835C107.418 73.1468 108.304 72.8027 109.448 72.8027C110.542 72.8027 111.408 73.1559 112.046 73.8623C112.684 74.5641 113.003 75.512 113.003 76.7061ZM107.5 76.7061C107.5 78.4515 108.145 79.3242 109.435 79.3242C110.711 79.3242 111.349 78.4515 111.349 76.7061C111.349 74.9788 110.706 74.1152 109.421 74.1152C108.746 74.1152 108.257 74.3385 107.951 74.7852C107.65 75.2318 107.5 75.8721 107.5 76.7061ZM121.507 80.5H119.894V75.8516C119.894 75.2682 119.775 74.833 119.538 74.5459C119.306 74.2588 118.934 74.1152 118.424 74.1152C117.745 74.1152 117.248 74.3158 116.934 74.7168C116.619 75.1178 116.462 75.79 116.462 76.7334V80.5H114.855V72.9395H116.113L116.339 73.9307H116.421C116.649 73.5706 116.972 73.2926 117.392 73.0967C117.811 72.9007 118.276 72.8027 118.786 72.8027C120.6 72.8027 121.507 73.7256 121.507 75.5713V80.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 123.5,
    y1: -3,
    x2: 123.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: -3,
    x2: 60.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 57.5,
    x2: 200,
    y2: 57.5,
    stroke: "#2A7AFF",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 92.5,
    x2: 200,
    y2: 92.5,
    stroke: "#2A7AFF",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.5,
    y1: -3,
    x2: 138.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.5,
    y1: -3,
    x2: 75.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(121 31)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.983 45H126.712V36.5713L124.162 37.5078V36.3594L127.785 34.999H127.983V45ZM136.651 35.04V36.1133H136.419C135.435 36.1315 134.651 36.4232 134.067 36.9883C133.484 37.5534 133.147 38.3486 133.056 39.374C133.58 38.7725 134.295 38.4717 135.202 38.4717C136.068 38.4717 136.758 38.777 137.273 39.3877C137.793 39.9984 138.053 40.7868 138.053 41.7529C138.053 42.7783 137.772 43.5986 137.212 44.2139C136.656 44.8291 135.909 45.1367 134.97 45.1367C134.017 45.1367 133.245 44.7721 132.652 44.043C132.06 43.3092 131.764 42.3659 131.764 41.2129V40.7275C131.764 38.8955 132.153 37.4964 132.933 36.5303C133.716 35.5596 134.881 35.0628 136.426 35.04H136.651ZM134.99 39.5244C134.557 39.5244 134.159 39.6543 133.794 39.9141C133.429 40.1738 133.176 40.4997 133.035 40.8916V41.3564C133.035 42.1768 133.22 42.8376 133.589 43.3389C133.958 43.8402 134.418 44.0908 134.97 44.0908C135.539 44.0908 135.986 43.8812 136.31 43.4619C136.638 43.0426 136.802 42.4935 136.802 41.8145C136.802 41.1309 136.635 40.5794 136.303 40.1602C135.975 39.7363 135.537 39.5244 134.99 39.5244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(58 31)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9834 45H63.7119V36.5713L61.1621 37.5078V36.3594L64.7852 34.999H64.9834V45ZM73.6514 35.04V36.1133H73.4189C72.4346 36.1315 71.6507 36.4232 71.0674 36.9883C70.484 37.5534 70.1468 38.3486 70.0557 39.374C70.5798 38.7725 71.2952 38.4717 72.2021 38.4717C73.068 38.4717 73.7585 38.777 74.2734 39.3877C74.793 39.9984 75.0527 40.7868 75.0527 41.7529C75.0527 42.7783 74.7725 43.5986 74.2119 44.2139C73.6559 44.8291 72.9085 45.1367 71.9697 45.1367C71.0173 45.1367 70.2448 44.7721 69.6523 44.043C69.0599 43.3092 68.7637 42.3659 68.7637 41.2129V40.7275C68.7637 38.8955 69.1533 37.4964 69.9326 36.5303C70.7165 35.5596 71.8809 35.0628 73.4258 35.04H73.6514ZM71.9902 39.5244C71.5573 39.5244 71.1585 39.6543 70.7939 39.9141C70.4294 40.1738 70.1764 40.4997 70.0352 40.8916V41.3564C70.0352 42.1768 70.2197 42.8376 70.5889 43.3389C70.958 43.8402 71.4183 44.0908 71.9697 44.0908C72.5394 44.0908 72.986 43.8812 73.3096 43.4619C73.6377 43.0426 73.8018 42.4935 73.8018 41.8145C73.8018 41.1309 73.6354 40.5794 73.3027 40.1602C72.9746 39.7363 72.5371 39.5244 71.9902 39.5244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(157 66)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.666 74.4082H162.616C163.213 74.3991 163.683 74.2419 164.024 73.9365C164.366 73.6312 164.537 73.2188 164.537 72.6992C164.537 71.5326 163.956 70.9492 162.794 70.9492C162.247 70.9492 161.81 71.1064 161.481 71.4209C161.158 71.7308 160.996 72.1432 160.996 72.6582H159.731C159.731 71.8698 160.019 71.2158 160.593 70.6963C161.172 70.1722 161.905 69.9102 162.794 69.9102C163.733 69.9102 164.469 70.1585 165.002 70.6553C165.535 71.152 165.802 71.8424 165.802 72.7266C165.802 73.1595 165.66 73.5788 165.378 73.9844C165.1 74.39 164.719 74.693 164.236 74.8936C164.783 75.0667 165.205 75.3538 165.501 75.7549C165.802 76.1559 165.952 76.6458 165.952 77.2246C165.952 78.1178 165.66 78.8265 165.077 79.3506C164.494 79.8747 163.735 80.1367 162.801 80.1367C161.867 80.1367 161.105 79.8838 160.518 79.3779C159.934 78.8721 159.643 78.2044 159.643 77.375H160.914C160.914 77.8991 161.085 78.3184 161.427 78.6328C161.769 78.9473 162.227 79.1045 162.801 79.1045C163.411 79.1045 163.879 78.945 164.202 78.626C164.526 78.307 164.688 77.849 164.688 77.252C164.688 76.6732 164.51 76.2288 164.154 75.9189C163.799 75.609 163.286 75.4495 162.616 75.4404H161.666V74.4082ZM172.651 70.04V71.1133H172.419C171.435 71.1315 170.651 71.4232 170.067 71.9883C169.484 72.5534 169.147 73.3486 169.056 74.374C169.58 73.7725 170.295 73.4717 171.202 73.4717C172.068 73.4717 172.758 73.777 173.273 74.3877C173.793 74.9984 174.053 75.7868 174.053 76.7529C174.053 77.7783 173.772 78.5986 173.212 79.2139C172.656 79.8291 171.909 80.1367 170.97 80.1367C170.017 80.1367 169.245 79.7721 168.652 79.043C168.06 78.3092 167.764 77.3659 167.764 76.2129V75.7275C167.764 73.8955 168.153 72.4964 168.933 71.5303C169.716 70.5596 170.881 70.0628 172.426 70.04H172.651ZM170.99 74.5244C170.557 74.5244 170.159 74.6543 169.794 74.9141C169.429 75.1738 169.176 75.4997 169.035 75.8916V76.3564C169.035 77.1768 169.22 77.8376 169.589 78.3389C169.958 78.8402 170.418 79.0908 170.97 79.0908C171.539 79.0908 171.986 78.8812 172.31 78.4619C172.638 78.0426 172.802 77.4935 172.802 76.8145C172.802 76.1309 172.635 75.5794 172.303 75.1602C171.975 74.7363 171.537 74.5244 170.99 74.5244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5360_312156",
    x: 57,
    y: 55,
    width: 85,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5360_312156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5360_312156",
    result: "effect2_dropShadow_5360_312156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5360_312156"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5360_312156",
    result: "effect3_dropShadow_5360_312156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5360_312156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5360_312156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecRegular1);
export default __webpack_public_path__ + "static/media/spec-regular-1.e480673e628adcc88b9c2b48dc6db1bc.svg";
export { ForwardRef as ReactComponent };